import * as React from "react";
import {
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  styled,
} from "@mui/material";
import AssessmentOutlinedIcon from "@mui/icons-material/AssessmentOutlined";
import { useHistory } from "react-router";
import { reports } from "./clinicReports";

const ReportButton = styled(ListItemButton)({
  gap: 8,
});

export const ReportsList = () => {
  const history = useHistory();

  return (
    <List>
      {reports.map((report, index) => (
        <ListItem
          disablePadding
          onClick={() => history.push(report.name)}
          key={"report" + index}
        >
          <ReportButton>
            <ListItemIcon>
              <AssessmentOutlinedIcon />
            </ListItemIcon>
            <ListItemText primary={report.title} />
          </ReportButton>
        </ListItem>
      ))}
    </List>
  );
};
